import React from 'react';
import { MapPinIcon, CarIcon } from 'lucide-react';
interface MapViewProps {
  showDriver?: boolean;
  className?: string;
}
export const MapView: React.FC<MapViewProps> = ({
  showDriver = false,
  className = ''
}) => {
  return <div className={`relative bg-card rounded-lg overflow-hidden ${className}`} data-id="element-94">
      {/* This is a mock map view with styling to match the black UI with yellow accents */}
      <div className="h-full w-full bg-gradient-to-b from-card to-background p-4" data-id="element-95">
        {/* Mock map content */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-96">
          <MapPinIcon size={32} className="text-primary" data-id="element-97" />
        </div>
        {showDriver && <div className="absolute top-1/3 left-1/4" data-id="element-98">
            <div className="relative" data-id="element-99">
              <div className="h-1 w-20 bg-primary absolute -left-20 top-3 rotate-45" data-id="element-100"></div>
              <CarIcon size={24} className="text-primary" data-id="element-101" />
            </div>
          </div>}
        {/* Mock road lines */}
        <div className="absolute top-1/2 left-0 right-0 h-px bg-primary bg-opacity-30" data-id="element-102"></div>
        <div className="absolute top-0 bottom-0 left-1/3 w-px bg-primary bg-opacity-30" data-id="element-103"></div>
      </div>
    </div>;
};